import React, { useState } from 'react'
import { useInfiniteQuery } from 'react-query'

import {
  SaleBookTableRowAcceptProps,
  SaleBookTableRowProps,
} from '@features/myWriting/pages/MyWritingPage/components/SaleSummary/components/SummarySaleDetail/components/SaleBookDetail/components/SaleBookTableRow/interface'
import { useWriterAction } from '@hooks/writer/useWriterAction'
import { PaginatedWriterBookSaleDetail } from '@models/writer/PaginatedWriterBookSaleDetail'

const PER_PAGE = 10

const withSaleBookTableRow = (Component: React.FC<SaleBookTableRowProps>) => {
  function WithSaleBookTableRow({
    data,
    dateSelected,
    type,
    userId,
  }: SaleBookTableRowAcceptProps) {
    const writerClient = useWriterAction()
    const [isShowSubRow, setIsShowSubRow] = useState<boolean>(false)

    const {
      fetchNextPage,
      data: saleDetail,
      isFetchingNextPage,
      hasNextPage,
      isLoading,
    } = useInfiniteQuery(
      ['sale-book-detail', data.id, dateSelected, type],
      async ({ pageParam = 1 }) => {
        const res = await writerClient.getWriterSalesDetailByProductType({
          page: pageParam,
          limitPerPage: PER_PAGE,
          startDate: dateSelected.startDate,
          endDate: dateSelected.endDate,
          productType: type,
          bookIdOrEbookId: data.id,
          userId,
        })

        return res
      },
      {
        getNextPageParam: (lastPage: PaginatedWriterBookSaleDetail) => {
          if (lastPage.page * PER_PAGE < lastPage.total)
            return lastPage.page + 1

          return undefined
        },
        enabled: isShowSubRow,
      }
    )

    function handleFetchNextPage(event: any) {
      const scrollHeight = event.target.scrollHeight - 10
      const scrollTop = event.target.scrollTop + event.target.offsetHeight
      if (scrollHeight <= scrollTop && !isFetchingNextPage && hasNextPage) {
        fetchNextPage()
      }
    }

    const handleToggleShowSubRow = () => {
      setIsShowSubRow(!isShowSubRow)
    }

    const newProps = {
      data,
      saleDetail,
      isShowSubRow,
      isFetchingNextPage,
      isLoading,
      handleToggleShowSubRow,
      handleFetchNextPage,
    }
    return <Component {...newProps} />
  }

  return WithSaleBookTableRow
}
export default withSaleBookTableRow
